/**
 * **GIFT LINKS** — one Suikamon for whoever opens the link and signs in (the giveaway prize).
 * The path is written once, here: the Admin page and the Telegram `/airdrop` command build the
 * link with {@link giftLinkUrl}, and the web app routes `${GIFT_LINK_PATH}/:code`.
 */

export const GIFT_LINK_PATH = "/gift";

/** `https://suikamon.com/gift/<code>` for a code from `airdrop_codes`. */
export function giftLinkUrl(publicUrl: string, code: string): string {
  return `${publicUrl.replace(/\/+$/, "")}${GIFT_LINK_PATH}/${encodeURIComponent(code)}`;
}
